{
  "manager": {
    "integrationsCard": {
      "disconnect": "Disconnect",
      "disconnectTitle": "Disconnect {label}",
      "disconnectBody": "Disconnecting removes the active connection and immediately disables its features.",
      "requestDtdAccount": "Request a DTD account",
      "secretSaved": "Saved — enter a new value to replace it.",
      "secretPlaceholder": "Enter a new value to update",
      "maxLengthError": "Use 255 characters or fewer.",
      "connected": "Connected",
      "notConnected": "Not connected",
      "updateConnection": "Update Connection",
      "connect": "Connect"
    }
  }
}
